import { Files, InfoFiles } from '../../../services/journey.service';
import MyFilesV2Model from '../model';

const CATEGORY_MAP: Record<string, { key: keyof Files | Array<keyof Files>; title: string }> = {
  'pedidos-e-receita': { key: ['requests'], title: 'Pedidos e receitas' },
  relatorios: { key: ['reports', 'surgicalReports'], title: 'Relatórios' },
  'declaracao-de-comparecimento': { key: 'surgicalReports', title: 'Declaração de comparecimento' },
  'video-cirurgico': { key: 'surgicalVideos', title: 'Vídeo cirúrgico' },
  // outros: { key: 'others', title: 'Outros' },
  'meus-exames': { key: 'exams', title: 'Meus exames' }
};

export default class FileListPageModel {
  static resolveCategory(files: Files | null, category: string): InfoFiles[] {
    if (!files) return [];
    if (category === 'todos') return MyFilesV2Model.mergeAllFiles(files);
    const config = CATEGORY_MAP[category];
    if (!config) return [];
    if (Array.isArray(config.key)) return config.key.flatMap(k => files[k]);
    return files[config.key];
  }

  static resolveTitle(category: string): string {
    if (category === 'todos') return 'Todos os arquivos';
    return CATEGORY_MAP[category]?.title ?? 'Arquivos';
  }

  static sortByDate = MyFilesV2Model.sortByDate;
  static filterByYear = MyFilesV2Model.filterByYear;
  static extractYears = MyFilesV2Model.extractYears;
  static getPage = MyFilesV2Model.getPage;
}
